import { axiosApi } from 'app/api/api';
import { CreateFileParams, FileData } from 'entities/file/model/fileModel';
import { UpdateFileParams } from 'entities/file/model/updateFileHelper';

const hashImage = (src: string) => {
  return `${src}?hash=${String(Math.random())}`;
};

export const filesApi = {
  fetch: async (id: string, { in_trash }: { in_trash: string | null }) => {
    const res = await axiosApi.get<FileData>(`/file/${id}`, {
      params: { in_trash },
    });

    return res.data;
  },

  fetchFavourits: async () => {
    const res = await axiosApi.get<{ favorite_files: FileData[] }>(
      `/favorites/files`
    );

    return res.data.favorite_files;
  },
  fetchOwn: async () => {
    const res = await axiosApi.get<{ files: FileData[] }>(`/file/user_files`);

    return res.data.files;
  },
  fetchTrash: async () => {
    const res = await axiosApi.get<{ files: FileData[] }>(`/trash/`);

    return res.data.files;
  },

  setFavourite: async (id: string, isFavorite: boolean) => {
    if (isFavorite) {
      await axiosApi.post(`/favorites`, {
        id,
        content_type: 'FILE',
      });
    } else {
      await axiosApi.delete(`/favorites?id=${id}&content_type=FILE`);
    }

    return isFavorite;
  },

  update: async (id: string, params: UpdateFileParams) => {
    const fd = new FormData();

    if (params.section_id) {
      fd.append('section_id', params.section_id);
    }
    if (params.folder_id) {
      fd.append('folder_id', params.folder_id);
    }

    fd.append('name', params.name || '');
    fd.append('preview', params.previewFile || '');
    fd.append('new_file', params.file || '');

    const res = await axiosApi.put<FileData>(`/file/${id}`, fd);

    res.data.preview_url = res.data.preview_url
      ? hashImage(res.data.preview_url)
      : res.data.preview_url;
    res.data.source_preview_url = res.data.source_preview_url
      ? hashImage(res.data.source_preview_url)
      : res.data.source_preview_url;

    return res.data;
  },

  uploadFolder: (
    { file, ...other }: CreateFileParams,
    onProgress: (val: number) => void
  ) => {
    const fd = new FormData();

    fd.append('zip_file', file);
    if (other.folder_id) {
      // MOCK: Костыль под глобальное флоу
      // @ts-ignore
      other.parent_id = other.folder_id;
      delete other.folder_id;
    }

    const controller = new AbortController();

    const promise = axiosApi.post<void>('/file/proces_zip', fd, {
      params: other,
      signal: controller.signal,
      onUploadProgress: (e) => {
        onProgress(e.progress || 1);
      },
    });

    return [controller, promise] as const;
  },

  createInFolder: (
    params: CreateFileParams,
    onProgress: (val: number) => void
  ) => {
    const fd = new FormData();

    fd.append('file', params.file);

    if (params.previewFile) {
      fd.append('preview', params.previewFile);
    }

    if (params.folder_id) {
      fd.append('folder_id', params.folder_id);
    }

    const controller = new AbortController();

    const promise = axiosApi.post<void>('/file/', fd, {
      signal: controller.signal,
      onUploadProgress: (e) => {
        onProgress(e.progress || 1);
      },
    });

    return [controller, promise] as const;
  },

  createInSection: (
    params: CreateFileParams,
    onProgress: (val: number) => void
  ) => {
    const fd = new FormData();

    fd.append('file', params.file);

    if (params.previewFile) {
      fd.append('preview', params.previewFile);
    }

    fd.append('section_id', params.section_id);

    const controller = new AbortController();

    const promise = axiosApi.post<void>('/file/upload_non_folder_file', fd, {
      signal: controller.signal,
      onUploadProgress: (e) => {
        onProgress(e.progress || 1);
      },
    });

    return [controller, promise] as const;
  },

  delete: async (id: string) => {
    await axiosApi.delete(`/file/${id}`);

    return true;
  },

  deletePreview: async (id: string) => {
    await axiosApi.delete(`/file/preview/${id}`);

    return true;
  },
};
